import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import { findMatch } from '@/utils/resultsHelper';
import {
  activeReports,
  dataModelReportsDownloadState,
  findDataModelReport,
  reportDownloadState,
} from './state';
import actions from '../constants';

const fetchDataModelReports = withDraft((draft, action) => {
  const item = findDataModelReport(draft, action);

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
    item.items = [];
  } else {
    draft.dataModelReports[action.category].results.push({
      code: action.code,
      readStatus: states.PENDING,
      readErrors: [],
      items: [],
    });
  }
});

const fetchDataModelReportsSuccess = withDraft((draft, action) => {
  const item = findDataModelReport(draft, action);

  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.items = action.result.items;
});

const fetchDataModelReportsError = withDraft((draft, action) => {
  const item = findDataModelReport(draft, action);

  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const showDataModelReports = withDraft((draft, action) => {
  draft.dataModelReportsDialog.open = true;
  draft.dataModelReportsDialog.category = action.category;
  draft.dataModelReportsDialog.code = action.code;
  draft.dataModelReportsDialog.name = action.name;
});

const hideDataModelReports = withDraft((draft, action) => {
  draft.dataModelReportsDialog = activeReports('datamodel');
  draft.dataModelReports[action.category].results = [];
  draft.dataModelReports.downloads.results = [];
});

const dataModelReportDownload = withDraft((draft, action) => {
  const item = findDataModelReport(draft, action);

  if (item) {
    const report = findMatch(item.items, action.report.id, 'reportId');
    if (report) {
      report.readStatus = states.PENDING;
      report.readErrors = [];
    } else {
      item.items.push({
        ...reportDownloadState(),
        reportId: action.report.id,
        readStatus: states.PENDING,
      });
    }
  } else {
    draft.dataModelReports[action.category].results.push({
      ...dataModelReportsDownloadState(),
      code: action.code,
    });
    const newItem = findDataModelReport(draft, action);
    newItem.items.push({
      ...reportDownloadState(),
      reportId: action.report.id,
      readStatus: states.PENDING,
    });
  }
});

const dataModelReportDownloadSuccess = withDraft((draft, action) => {
  const item = findDataModelReport(draft, action);
  const report = findMatch(item.items, action.report.id, 'reportId');

  report.data = action.response;
  report.readStatus = states.SUCCESS;
  report.readErrors = [];
});

const dataModelReportDownloadError = withDraft((draft, action) => {
  const item = findDataModelReport(draft, action);
  const report = findMatch(item.items, action.report.id, 'reportId');

  report.readStatus = states.ERROR;
  report.readErrors = [responseError(action)];
});

export default {
  [actions.DATA_MODEL_REPORT_DOWNLOAD]: dataModelReportDownload,
  [actions.DATA_MODEL_REPORT_DOWNLOAD_ERROR]: dataModelReportDownloadError,
  [actions.DATA_MODEL_REPORT_DOWNLOAD_SUCCESS]: dataModelReportDownloadSuccess,
  [actions.FETCH_DATA_MODEL_REPORTS]: fetchDataModelReports,
  [actions.FETCH_DATA_MODEL_REPORTS_ERROR]: fetchDataModelReportsError,
  [actions.FETCH_DATA_MODEL_REPORTS_SUCCESS]: fetchDataModelReportsSuccess,
  [actions.HIDE_DATA_MODEL_REPORTS]: hideDataModelReports,
  [actions.SHOW_DATA_MODEL_REPORTS]: showDataModelReports,
};
